import React, { createContext, useState, useContext } from 'react'
interface IModalContext {
  modalOpen: string
  openModal: (modalId: string) => void
  closeModal: () => void
  modalIsOpen: boolean
  modalContent: React.ReactNode
  setModalIsOpen: (isOpen: boolean) => void
  setModalContent: (content: React.ReactNode) => void
}

export const ModalContext = createContext<IModalContext | undefined>(undefined)

type IModalProvider = {
  children: React.ReactNode
  initialOpen?: string
}

const CLOSED_MODAL_STATE = 'closed-modal'

export function ModalProvider({ children, initialOpen = CLOSED_MODAL_STATE }: IModalProvider) {
  const [modalOpen, setModalOpen] = useState(initialOpen)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [modalContent, setModalContent] = useState<React.ReactNode>(null)

  function openModal(modalId: string) {
    setModalOpen(modalId)
  }

  function closeModal() {
    setModalOpen(CLOSED_MODAL_STATE)
  }

  return (
    <ModalContext.Provider
      value={{
        modalOpen,
        openModal,
        closeModal,
        modalIsOpen,
        setModalIsOpen,
        modalContent,
        setModalContent,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export const useModalContext = (): IModalContext => {
  const context = useContext(ModalContext)
  if (!context) {
    throw new Error('useModalContext should be use within ModalContextProvider')
  }

  return context
}
